import React, { useState, useEffect } from "react";
import moment from "moment";
import Notify from '../Notify.js';
import TablaEstadisticas from './TablaEstadisticas';
import TablaDetalleDespachos from './TablaDetalleDespachos';

const DashboardEstadisticas = () => {
    const [fechaBusquedaInicio, setFechaBusquedaInicio] = useState(moment().format('YYYY-MM-DD'));
    const [fechaBusquedaFin, setFechaBusquedaFin] = useState(moment().format('YYYY-MM-DD'));
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [reporteData, setReporteData] = useState(null);
    const [showEstadisticas, setShowEstadisticas] = useState(false);
    const [showHelp, setShowHelp] = useState(false);

    const [detalleData, setDetalleData] = useState(null);
    const [isDetalleLoading, setIsDetalleLoading] = useState(false);
    const [showDetalle, setShowDetalle] = useState(false);

    const ToDay = () => moment().format('YYYY-MM-DD');

    const handleChangeFechaBusqueda = (e) => {
        const { name, value } = e.target;

        if (name === 'fechaBusquedaInicio') {
            setFechaBusquedaInicio(value);
            if (moment(value).isAfter(moment(fechaBusquedaFin))) {
                setFechaBusquedaFin(value);
            }
        } else if (name === 'fechaBusquedaFin') {
            setFechaBusquedaFin(value);
        }

        // Limpiar datos previos si cambian las fechas
        setReporteData(null);
        setShowEstadisticas(false);
        setDetalleData(null);
        setShowDetalle(false);
        setError(null);
    };

    const generarEstadisticas = async () => {
        if (!fechaBusquedaInicio) {
            return Notify("Debes ingresar una fecha de inicio", "warning", 1500);
        }
        if (!fechaBusquedaFin) {
            return Notify("Debes ingresar una fecha de fin", "warning", 1500);
        }

        setIsLoading(true);
        setError(null);
        setReporteData(null);

        try {
            const response = await fetch('/api/despacho/dashboard/estadisticas', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    fechaInicio: fechaBusquedaInicio + ' 00:00:00',
                    fechaFin: fechaBusquedaFin + ' 23:59:59'
                })
            });

            if (!response.ok) {
                throw new Error(`Error HTTP: ${response.status}`);
            }

            const data = await response.json();

            if (data.ok) {
                setReporteData(data);
                setShowEstadisticas(true);
                Notify("Estadísticas generadas exitosamente", "success", 2000);
            } else {
                throw new Error(data.error || "Error en la respuesta del servidor");
            }

        } catch (err) {
            setError(err.message);
            Notify("Error al generar las estadísticas", "error", 2500);
        } finally {
            setIsLoading(false);
        }
    };

    const generarDetalleTiempos = async () => {
        if (!fechaBusquedaInicio || !fechaBusquedaFin) {
            return Notify("Debes ingresar fechas válidas", "warning", 1500);
        }

        setIsDetalleLoading(true);
        setDetalleData(null);

        try {
            const response = await fetch('/api/despacho/dashboard/detalle-tiempos', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    fechaInicio: fechaBusquedaInicio + ' 00:00:00',
                    fechaFin: fechaBusquedaFin + ' 23:59:59'
                })
            });

            if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
            const data = await response.json();

            if (data.ok) {
                setDetalleData(data.data);
                setShowDetalle(true);
            } else {
                throw new Error(data.error);
            }
        } catch (err) {
            Notify("Error al cargar detalles: " + err.message, "error", 2500);
        } finally {
            setIsDetalleLoading(false);
        }
    };

    const styleCalendar = {
        border: "0.5px solid #acacac",
        borderRadius: "25px",
        outline: "none",
        flexBasis: "50%",
        alignSelf: "center"
    };

    return (
        <div className="animated fadeIn">
            <div className="justify-content-center contenedor-fecha-fpay caja-fondo-blanco-m-2 mt-3">
                <span className="align-self-center letra-fecha-fpay">
                    Desde:
                </span>
                <input
                    type="date"
                    name="fechaBusquedaInicio"
                    onChange={handleChangeFechaBusqueda}
                    value={fechaBusquedaInicio}
                    className="input__linea mr-1 mt-3 mb-3 linea-fecha-fpay"
                    style={styleCalendar}
                    max={ToDay()}
                />
                <span className="align-self-center letra-fecha-fpay">
                    Hasta:
                </span>
                <input
                    type="date"
                    name="fechaBusquedaFin"
                    onChange={handleChangeFechaBusqueda}
                    value={fechaBusquedaFin}
                    className="input__linea mr-1 mt-3 mb-3 linea-fecha-fpay"
                    style={styleCalendar}
                    min={fechaBusquedaInicio}
                    max={ToDay()}
                />
            </div>

            <div className="container">
                <div className="mb-2 mt-2">
                    <button
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => setShowHelp(true)}
                        title="Ver guía de uso"
                    >
                        <i className="fas fa-question-circle mr-1" /> HELP
                    </button>
                    <span style={{ color: '#eb0000ff' }}>BETA</span>
                </div>

                {isLoading && (
                    <div className="alert alert-info">
                        <span className="spinner-border spinner-border-sm mr-2"></span>
                        Generando estadísticas del dashboard...
                    </div>
                )}

                {error && (
                    <div className="alert alert-danger">
                        Error: {error}
                    </div>
                )}

                <div className="caja-fondo-blanco-m-2 p-3 mb-3 shadow-sm border-0">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h4 className="sucursal-text-color mb-3" style={{ color: '#35605a' }}>
                                Estadísticas Generales de Despacho
                            </h4>
                            <p className="text-muted mb-4">
                                Seleccione el rango de fechas para visualizar la eficiencia operativa, top de productos despachados, desempeño de vendedores y análisis de clientes recurrentes.
                            </p>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-12 d-flex justify-content-center">
                            <button
                                className="btn btn-verde-mfp px-5 py-2 font-weight-bold"
                                onClick={() => {
                                    if (showEstadisticas) {
                                        setShowEstadisticas(false);
                                    } else {
                                        generarEstadisticas();
                                    }
                                }}
                                disabled={isLoading}
                                style={{ borderRadius: '25px', backgroundColor: '#35605a', color: 'white', border: 'none' }}
                            >
                                {isLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm mr-2"></span>
                                        Procesando datos...
                                    </>
                                ) : (
                                    <>
                                        <i className={`fas fa-${showEstadisticas ? 'eye-slash' : 'chart-line'} mr-2`}></i>
                                        {showEstadisticas ? 'Ocultar Estadísticas' : 'Generar Estadísticas'}
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                {showEstadisticas && reporteData && !isLoading && (
                    <TablaEstadisticas
                        reporteData={reporteData}
                        fechaInicio={fechaBusquedaInicio}
                        fechaFin={fechaBusquedaFin}
                    />
                )}

                <div className="row mt-4 mb-4">
                    <div className="col-12 text-center">
                        <hr />
                        <h5 className="sucursal-text-color mb-3 mt-3" style={{ color: '#35605a' }}>
                            Análisis Detallado de Tiempos por Despacho
                        </h5>
                        <p className="text-muted mb-4">
                            Este reporte desglosa el ciclo de vida de cada venta finalizada, midiendo de forma independiente el **Tiempo en Cola** (minutos que el pedido esperó antes de ser atendido) y el **Tiempo en Proceso** (minutos que le tomó al operario preparar y entregar los productos). Permite evaluar la eficiencia del personal de almacén, identificar demoras en la atención y detectar desviaciones operativas en tiempo real.
                        </p>
                        <button
                            className="btn btn-outline-secondary px-4 py-2 font-weight-bold"
                            onClick={() => {
                                if (showDetalle) {
                                    setShowDetalle(false);
                                } else {
                                    generarDetalleTiempos();
                                }
                            }}
                            disabled={isDetalleLoading}
                            style={{ borderRadius: '25px' }}
                        >
                            {isDetalleLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm mr-2"></span>
                                    Cargando detalles...
                                </>
                            ) : (
                                <>
                                    <i className={`fas fa-${showDetalle ? 'eye-slash' : 'search'} mr-2`}></i>
                                    {showDetalle ? 'Ocultar Detalle' : 'Visualizar Detalle de Despachos'}
                                </>
                            )}
                        </button>
                    </div>
                </div>

                {showDetalle && detalleData && (
                    <TablaDetalleDespachos data={detalleData} />
                )}
            </div>

            {showHelp && (
                <div
                    className="modal fade show"
                    style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
                    role="dialog"
                    aria-modal="true"
                >
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header text-white" style={{ background: '#35605a' }}>
                                <h5 className="modal-title">
                                    <i className="fas fa-book-open mr-2" />
                                    Guía: Dashboard de Estadísticas de Despacho
                                </h5>
                                <button
                                    type="button"
                                    className="close text-white"
                                    onClick={() => setShowHelp(false)}
                                    aria-label="Cerrar"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="alert alert-info">
                                    <i className="fas fa-info-circle mr-2" />
                                    Esta herramienta consolida métricas clave para la evaluación del rendimiento operativo en despachos.
                                </div>

                                <h6 className="font-weight-bold text-success"><i className="fas fa-calendar-alt mr-2" />1. Filtros de fecha</h6>
                                <p>Seleccione el periodo que desea analizar. El sistema considerará todas las operaciones finalizadas o creadas dentro de este margen.</p>

                                <h6 className="font-weight-bold text-success"><i className="fas fa-truck-loading mr-2" />2. Despachadores Eficientes</h6>
                                <p>Mide la velocidad operativa calculando la diferencia (en minutos y segundos) entre el inicio del proceso de un despacho y su finalización por parte del personal de almacén.</p>

                                <h6 className="font-weight-bold text-success"><i className="fas fa-box-open mr-2" />3. Productos Top Despachados</h6>
                                <p>Lista los ítems con mayor rotación en el periodo, detallando la cantidad de unidades movilizadas.</p>

                                <h6 className="font-weight-bold text-success"><i className="fas fa-users mr-2" />4. Clientes Frecuentes</h6>
                                <p>Identifica los clientes con más recepciones de mercadería confirmadas y la inversión económica que esto representa.</p>

                                <h6 className="font-weight-bold text-success"><i className="fas fa-user-tie mr-2" />5. Eficiencia de Ventas</h6>
                                <p>Muestra qué vendedores están generando mayor volumen y monto de facturación que deriva en órdenes de despacho.</p>

                                <h6 className="font-weight-bold text-success"><i className="fas fa-clock mr-2" />6. Tiempos de Ausencia</h6>
                                <p>Registra y contabiliza las pausas operativas (tiempos muertos) solicitadas por el personal desde su terminal móvil.</p>

                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowHelp(false)}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DashboardEstadisticas;
